// export default {
//     name: "DSR Reports",
//     meta: {
//         icon: "directions_boat",
//         expanded: true,
//         auth: true,
//     },
//     departmentName: "Reports",
//     finalPagePermision: "Sea_Export_SLine_Payment",
//     children: [{
//         name: "Main Report",
//         path: "/freightForward/slinePay",
//         meta: {
//             auth: true,
//         },
//         component: require("../component/freightForwarding/slinePaymentDetails.vue"),
//         finalPagePermision: "Sea_Export_SLine_Payment",
//     }, ],
// };

// export default {
//     name: "DSR Reports",
//     path: "/mainReport",
//     permissionName: 'Sea Export',
//     keywords: ['DSR Reports'],
//     meta: {
//         icon: "dashboard",
//         auth: true
//     },
//     departmentName: "Dashboard",
//     finalPagePermision: "",

//     component: require("../component/allModuleForm/viewReports.vue")
// };

export default {
    name: "DSR Reports",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "DSR Reports",
    finalPagePermision: "",
    children: [{
        name: "Excell Template",
        path: "/excellTemp",
        permissionName: 'Excell Template',
        keywords: ['Sea Export DSR Reports', 'Sea_Exp_DSR_Reports','Excell Template','Sea Import DSR Reports'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/dsrReport/excellTemp.vue"),
        finalPagePermision: "Excell Template",
    },{
            name: "Sea Export DSR Reports",
            path: "/mainReport",
            permissionName: 'Sea_Exp_DSR_Reports',
            keywords: ['Sea Export DSR Reports', 'Sea_Exp_DSR_Reports','Excell Template','Sea Import DSR Reports'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/allModuleForm/viewReports.vue"),
            finalPagePermision: "Sea_Exp_DSR_Reports",
        },
        {
            name: "Sea Import DSR Reports",
            path: "/ImpmainReport",
            permissionName: 'Sea_Imp_DSR_Reports',
            keywords: ['Sea Import DSR Reports ', 'Sea_Imp_DSR_Reports','Excell Template','Sea Export DSR Reports'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/allModuleForm/viewDSRIMPReports.vue"),
            finalPagePermision: "Sea_Imp_DSR_Reports",
        },

    ],
};


// WEBPACK FOOTER //
// ./src/sidebar/dsrReport.js